import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import './styles/pages/main.css';
import './styles/pages/detail.css';
import './styles/pages/marketplace.css';
import './styles/pages/withdraw.css';
import './styles/pages/gameplay.css';
import './styles/pages/myNFT.css';
import './styles/pages/registerInvestor.css';
import './styles/pages/mint.css';
import './styles/pages/vision.css';
import './styles/pages/aboutHolysharks.css';
import './styles/pages/aboutNFT.css';
import './styles/pages/aboutMetaverse.css';
import './styles/pages/gallery.css';
import './styles/pages/godly.css';

import './styles/components/customBtn.css';
import './styles/components/customSearch.css';
import './styles/components/customSelection.css';
import './styles/components/customOption.css';
import './styles/components/customInput.css';
import './styles/components/customModal.css';
import './styles/components/customInputRange.css';
import './styles/components/itemSell.css';
import './styles/components/FAQElement.css';
import './styles/components/connectWallet.css';
import './styles/components/galleryItem.css';
import './styles/components/attribute.css';
import './styles/components/holysharksCGI.css';
import './styles/components/coral.css';

import './styles/components/economy/economyBubble.css';
import './styles/components/economy/economyGraph.css';
import './styles/components/economy/economyFormula.css';

import './styles/components/roadmap/roadmapElement.css';
import './styles/components/roadmap/roadmap.css';

import './styles/components/menu.css';
import './styles/components/itemNFT.css';
import './styles/components/scrollToTop.css';


import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
